let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("dDCdM")).then(() => parcelRequire('3x0ud'));